import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ReportGetCustomFields, ReportGetCustomFieldsResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ReportGetCustomFieldsResponse, ReportGetCustomFieldsResponse>) => {
    return response?.data?.data
}
const getError = (response?: SWRResponse<ReportGetCustomFieldsResponse, ReportGetCustomFieldsResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const useReportCustomTemplateFields = (configuration?: SWRConfiguration<ReportGetCustomFieldsResponse, ReportGetCustomFieldsResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new ReportGetCustomFields();
        };
    }, [])

    return useGet(request, { getData, getError }, configuration);
}

export default useReportCustomTemplateFields;